// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__P3nHh","controls":"styles_controls__3Bb_l","charLimit":"styles_charLimit__23qB0","input":"styles_input__1pcfK","send":"styles_send__33o1B"};